import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Progress } from "antd";
import GetPerformanceStatsApi from "../../api/performance/GetPerformanceStatsApi";
import { SimpleLoader } from "../sub/Loaders";
import { Link } from "react-router-dom";

function PerformanceStats() {
  const [individualData, setIndividualData] = useState([]);
  const [organizationData, setOrganizationData] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const [data, setData] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);

  const positionState = useSelector((state) => state.positionState.value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPerformanceStats();
  }, [perfCycleState]);

  async function getPerformanceStats() {
    setLoading(true);
    const apiResponse = await GetPerformanceStatsApi(
      positionState?.id,
      perfCycleState?.id
    );

    if (apiResponse.success) {
      setIndividualData(apiResponse?.data?.individual);
      setOrganizationData(apiResponse?.data?.organization);
      setUnitData(apiResponse?.data?.unit);
      setData(apiResponse?.data);
      setLoading(false);
    }
  }
  function getGraph(performance) {
    if (performance.performanceStatus === "At Risk") {
      return (
        <Progress
          percent={performance.performance}
          strokeColor={"#f50"}
          strokeLinecap="square"
          size="large"
          showInfo={false}
        />
      );
    } else if (performance.performanceStatus === "Off Track") {
      return (
        <Progress
          percent={performance.performance}
          strokeColor={"#FAB324"}
          strokeLinecap="square"
          size="large"
          showInfo={false}
        />
      );
    } else if (performance.performanceStatus === "On Track") {
      return (
        <Progress
          percent={performance.performance}
          strokeColor={"#87d068"}
          strokeLinecap="square"
          size="large"
          showInfo={false}
        />
      );
    }
  }

  return (
    <>
      <div className="grid grid-cols-3 gap-5 mb-10">
        {loading ? (
          <SimpleLoader />
        ) : (
          <Link
            to="/top-plans"
            className="border p-5 rounded-md text-black hover:text-black cursor-pointer"
          >
            <div className="flex items-center justify-between text-base mb-2">
              <div>Organization performance</div>
            </div>
            <div className="text-5xl">{organizationData?.performance} % </div>
            {getGraph(organizationData)}
          </Link>
        )}
        {loading ? (
          <SimpleLoader />
        ) : (
          <Link
            to={`/units/${unitData?.unitId}`}
            className="border p-5 rounded-md text-black hover:text-black cursor-pointer"
          >
            <div className="flex items-center justify-between text-base mb-2">
              <div>Unit performance</div>
            </div>
            <div className="text-5xl">{unitData?.performance}% </div>

            {getGraph(unitData)}
          </Link>
        )}
        {loading ? (
          <SimpleLoader />
        ) : (
          <Link
            to={`/positions-performance/${individualData?.positionId}`}
            className="border p-5 rounded-md text-black hover:text-black cursor-pointer"
          >
            <div className="flex items-center justify-between text-base mb-2">
              <div>Your performance</div>
            </div>
            <div className="text-5xl">{individualData?.performance}% </div>

            {getGraph(individualData)}
          </Link>
        )}
      </div>
    </>
  );
}

export default PerformanceStats;
